import { Select } from "common/InputForm";
import NotFound from "common/NotFound";
import useDebounce from "common/UseDebounce";
import useFullPageLoader from "common/UseFullPageLoader";
import { SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { prescriptionListApi } from "services/prescription-management";
import { isHighlighted, markRowOpened, subscribeSeen, prescriptionSeenId } from "utils/seenNotifications";
import { dateFormat } from "utils/dateFormat";
import findSerialNumber from "utils/findSerialNumber";
import "./prescription-scss.scss";
import Pagination from "react-js-pagination";

const PrescriptionManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();

  const navigate = useNavigate();

  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const userStatus = searchParams.get("status") || "";

  // ---------------search related
  const search = searchParams.get("search") || "";
  const debouncedValue = useDebounce(search, 300);

  const setSearchFun = (searchTxt) => {
    const newParams = new URLSearchParams(searchParams); // safe copy
    newParams.set("page", 1);
    newParams.set("search", searchTxt);
    setSearchParams(newParams);
  };

  // -----set limit and fetched List

  const [total, setTotal] = useState(null);
  const [prescriptionListState, setPrescriptionListState] = useState([]);

  // ---- notification row highlight: only the prescription the admin picked via
  // "View & Handle" stays light green, until its row is opened here ----
  const [, setSeenTick] = useState(0);
  useEffect(() => subscribeSeen(() => setSeenTick((n) => n + 1)), []);
  const isRowNew = (row) =>
    row?.status === "PENDING" && isHighlighted(prescriptionSeenId(row?._id));
  const handleOpenRow = (row) => {
    if (row?._id) markRowOpened(prescriptionSeenId(row._id));
  };

  // ---Prescription lists fetching

  //*********Handel Pagination********* */

  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  const fetchPrescriptionList = async (activePage, limit, userStatus) => {
    try {
      const query = { page: activePage, limit, status: userStatus };

      onShow();

      if (search && debouncedValue) {
        query.search = debouncedValue;
      }

      const {
        data: {
          status,
          code,
          data: { total, data },
        },
      } = await prescriptionListApi(query);

      if (status || data === 200) {
        setTotal(total);
        setPrescriptionListState(data);
      }
    } catch (error) {
      console.log("error while Prescription List Fetching ", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchPrescriptionList(activePage, limit, userStatus);
  }, [debouncedValue, activePage, limit, userStatus]);

  return (
    <div className="prescription-management-parent">
      {loader}

      <div className="page_title">
        <h3>Prescription Management</h3>
      </div>

      <div className="search_wrapper">
        <SearchBar
          placeholder={"Search..."}
          onKeyDown={(e) => {
            const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
            const controlKeys = [
              "Backspace",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
              "Tab",
              "Escape",
            ];

            // Allow letters, numbers, space, hyphen
            if (allowedKeysRegex.test(e.key) || controlKeys.includes(e.key)) {
              return;
            }

            // Block everything else
            e.preventDefault();
          }}
          onChange={(e) => setSearchFun(e.target.value)}
          value={search}
        />

        {/* -----select state */}
        <div>
          <Select
            className="select-status-option"
            value={userStatus}
            onChange={(e) => {
              const urlInstance = new URLSearchParams(searchParams);
              urlInstance.set("status", e.target.value);
              setSearchParams(urlInstance);
            }}
          >
            <option value="">All Status</option>
            <option value="APPROVED">APPROVED</option>
            <option value="PENDING">PENDING</option>
            <option value="REJECTED">REJECTED</option>
          </Select>
        </div>
      </div>
      {/* -----main card */}
      <div className="card">
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Customer ID</th>
                <th className="nowrap text-center">Pres. ID</th>
                <th className="nowrap text-center">Instruction</th>
                <th className="nowrap text-center">Customer Name</th>
                <th className="nowrap text-center">Days</th>
                <th className="nowrap text-center">Status</th>
                <th className="nowrap text-center">Date</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {prescriptionListState && prescriptionListState.length ? (
                prescriptionListState?.map((mapProp, index) => {
                  return (
                   <tr key = {index}
 style={isRowNew(mapProp) ? {
                            backgroundColor: '#d1e7dd',
                            boxShadow: 'inset 4px 0 0 #198754',
                          } : undefined}
 onClick={() => {
                            handleOpenRow(mapProp);
                            navigate(
                              `/prescription-management/userDetail/${mapProp._id}`

                            );
                          }}>


                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, limit)}
                      </td>

                      <td className="nowrap text-center">
                        {mapProp?.user?.customerId}
                      </td>
                      <td className="nowrap text-center">
                        {mapProp?.prescriptionId}
                      </td>
                      <td className="nowrap text-center">
                        {mapProp?.type || "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {mapProp?.user?.fullName || "-----"}
                      </td>

                      <td className="nowrap text-center">
                        {mapProp?.days || "-----"}
                      </td>
                      <td className="nowrap text-center">
                        <span
                          style={{
                            color:
                              mapProp?.status === "APPROVED"
                                ? "black"
                                : mapProp?.status === "PENDING"
                                  ? "#800080" // dark purple
                                  : "black",
                            fontWeight: ["PENDING"].includes(
                              mapProp?.status
                            )
                              ? "bold"
                              : "normal",
                          }}
                        >
                          {mapProp?.status || "-----"}
                        </span>
                      </td>

                      <td className="nowrap text-center">
                        {dateFormat(mapProp?.createdAt) || "-----"}
                      </td>

                      <td className="nowrap text-center">
                        <div className="icon_wrap">
                          <button
                            className="icon_button"
                            onClick={() => {
                              navigate(
                                `/prescription-management/userDetail/${mapProp._id}`
                              );
                            }}
                          >
                            <FaEye />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={7}
                  msg={"Brand data not found"}
                  onHide={onHide}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PrescriptionManagement;
